export default {
  screens: [
    {
      type: 'intro',
      title: ' 權力的象徵',
      content:
        '權力的象徵庇護七世冠冕是傳奇的媒介，見證了Chaumet和約瑟芬皇後相遇的緣起。',
      idYt: 'q7zuNJ10apM',
      videoCover: 'world/sovereign/video.jpg',
      desktop: {
        cover: 'world/sovereign/cover-1.jpg'
      },
      mobile: {
        cover: 'world/sovereign/mobile-cover-1.jpg',
        contentStyle: { width: '70%' },
        coverStyle: {
          width: '110%',
          top: '90%',
          left: '15%',
          position: 'absolute'
        }
      },
      isBottom: true
    },
    {
      type: 'columnVideo',
      content:
        '庇護七世冠冕是拿破侖爲了感謝教宗1804年12月2日到巴黎聖母院賜福加冕儀式而親自訂購的，是拿破侖最貴重的外交贈禮。 ',
      idYt: 'O-1TKgKxDdg',
      videoCover: 'world/sovereign/video-2.jpg',
      cover: 'world/sovereign/cover-2.jpg',
      isBottom: true
    },
    {
      type: 'video',
      middleImg: 'world/sovereign/tiare.jpg',
      videoBlock: {
        cover: 'world/sovereign/video-3.jpg',
        idYt: '5ExHUFrxFms'
      },
      content:
        '在此次展覽中，梵蒂岡委託Chaumet修復了皇冠，並設計了一個新十字架支撐頂部貴重華麗的祖母綠寶石。'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/cht/worlds/sovereign.js